import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { ProblemSection } from '../components/sections/ProblemSection';
import { SolutionSection } from '../components/sections/SolutionSection';
import { ResultsSection } from '../components/sections/ResultsSection';
import { AudienceSection } from '../components/sections/AudienceSection';
import { BenefitsSection } from '../components/sections/BenefitsSection';
import { CredibilitySection } from '../components/sections/CredibilitySection';
import { PricingSection } from '../components/sections/PricingSection';
import { HowItWorksSection } from '../components/sections/HowItWorksSection';
import { TestimonialSection } from '../components/sections/TestimonialSection';
import { FAQSection } from '../components/sections/FAQSection';
import { FooterSection } from '../components/sections/FooterSection';
import { SocialProofPopup } from '../components/ui/SocialProofPopup';
export function LandingPage() {
  return <main className="min-h-screen bg-background text-gray-700 font-body selection:bg-primary/30 selection:text-white" data-id="element-384">
      <HeroSection data-id="element-385" />
      <ProblemSection data-id="element-386" />
      <SolutionSection data-id="element-387" />
      <AudienceSection data-id="element-388" />
      <ResultsSection data-id="element-389" />
      <BenefitsSection data-id="element-390" />
      <PricingSection data-id="element-391" />
      <CredibilitySection data-id="element-392" />
      <HowItWorksSection data-id="element-393" />
      <TestimonialSection data-id="element-394" />
      <FAQSection data-id="element-395" />
      <FooterSection data-id="element-396" />
      <SocialProofPopup data-id="element-397" />
    </main>;
}